import { Helmet, HelmetProvider } from "react-helmet-async";
import ScrollTop from "../scrollTop";

const PageContainer = ({ title, description, children }) => {
  return (
    <HelmetProvider>
      <div>
        <Helmet>
          <title>{title}</title>
          <meta name="description" content={description} />
        </Helmet>
        <div>{children}</div>
        <ScrollTop />
      </div>
    </HelmetProvider>
  );
};

export default PageContainer;
